import { Carousel as BluBlocksCarousel } from "@bluframe/blublocks"

import { ComponentProps } from "."

const DEFAULT_COLUMN_GAP = 10

const Carousel = ({
  columnGap = DEFAULT_COLUMN_GAP,
  ...props
}: ComponentProps) => <BluBlocksCarousel {...props} columnGap={columnGap} />

export default Carousel
